import { ca } from '@cian/analytics';

export function trackSubmitAreaPartsOffer(ad, siteType, maxAreaPart, isSale) {
  const { priceType, paymentPeriod } = maxAreaPart;
  const isOfferEditing = !!ad.id;
  const product = {
    id: ad.id,
    offerType: 'offer',
    position: 1,
  };

  const priceTypeLabel = (() => {
    if (isSale) {
      return priceType === 'all' ? 'all' : 'm2';
    }

    if (priceType === 'squareMeter') {
      return paymentPeriod === 'annual' ? 'year_m2' : 'month_m2';
    }

    return 'month';
  })();

  const actionLabel = `${isSale ? 'sale' : 'rent'}_in_parts_${priceTypeLabel}`;

  ca('eventSite', {
    name: 'oldevent',
    category: isOfferEditing ? 'Edit_ad' : 'New_ad',
    action: 'Select',
    label: actionLabel,
    page: {
      pageType: 'AddForm',
      siteType,
    },
    products: isOfferEditing ? [product] : [],
  });
}
